import Vue from 'vue'
import Router from 'vue-router'
import {
  axiosHrClient,
  axiosReqCardClient,
  axiosReqCerClient,
  axiosNotiClient,
  axiosReqCardClient60s
} from '../plugins/axios'

import store from '../store'

import adminManage from './adminManage.router.js'
import login from './login.router.js'
import callback from './callback.router.js'
import home from './home.router.js'
import leave from './leave.router.js'
import leaveManage from './leave-manage.router.js'
import reqCard from './reqCard.router.js'
import reqCer from './reqCer.router.js'
import employee from './employee.router.js'
import history from './history.router.js'
import logout from './logout.router.js'
import setting from './setting.router.js'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    login,
    callback,
    home,
    leave,
    leaveManage,
    reqCard,
    reqCer,
    employee,
    history,
    adminManage,
    logout,
    setting,
    {
      path: '*',
      redirect: '/'
    }
  ]
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  // const isMaintenance = to.matched.some((record) => record.meta.isMaintenance);
  // console.log(isMaintenance)
  // var minute = 60
  // var now = new Date().getTime()
  // var setupTime = localStorage.getItem('setupTime')
  // if (setupTime == null) {
  //   localStorage.setItem('setupTime', now)
  // } else {
  //   if (now - setupTime > minute * 60 * 1000) {
  //     localStorage.clear()
  //     next('/login')
  //   } else {
  //     localStorage.setItem('setupTime', now)
  //   }
  // }
  let loggedIn = false
  if (localStorage.getItem('empInfo') != null) {
    if (!store.state.auth.employeeID) {
      store.commit(
        'auth/SET_EMP_INFO',
        JSON.parse(localStorage.getItem('empInfo'))
      )
    }
    axiosHrClient.defaults.headers.common.Authorization =
      'Bearer ' + localStorage.getItem('accesstoken')
    axiosReqCardClient.defaults.headers.common.Authorization =
      'Bearer ' + localStorage.getItem('accesstoken')
    axiosReqCerClient.defaults.headers.common.Authorization =
      'Bearer ' + localStorage.getItem('accesstoken')
    axiosNotiClient.defaults.headers.common.Authorization =
      'Bearer ' + localStorage.getItem('accesstoken')
    axiosReqCardClient60s.defaults.headers.common.Authorization =
      'Bearer ' + localStorage.getItem('accesstoken')
    // axiosReqCardClient.defaults.headers.common.Authorization = localStorage.getItem(
    //   'accesstoken'
    // )
    loggedIn = true
  }
  if (requiresAuth && !loggedIn) {
    next('/login')
  } else {
    /// Normal
    const navigation = to.meta.navMenu
    if (!navigation) {
      store.commit('navbar/UPDATE_INVISIBLE')
    } else {
      store.commit('navbar/UPDATE_VISIBLE', true)
      store.commit('navbar/UPDATE_STATUS', true)
      store.commit('navbar/UPDATE_LIST', navigation)
    }
    next()

    /// Maintenance
    // store.commit("navbar/UPDATE_INVISIBLE");
    // if (!isMaintenance) {
    //   next("/login/maintenance");
    // } else {
    //   next();
    // }
  }
})

export default router
